import { render, staticRenderFns } from "./navbar.vue?vue&type=template&id=2c106e47&"
import script from "./navbar.vue?vue&type=script&lang=js&"
export * from "./navbar.vue?vue&type=script&lang=js&"
import style0 from "./navbar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QHeader,QToolbar,QBtn,QToolbarTitle,QImg,QIcon,QMenu,QList,QItem,QItemSection,QDrawer,QAvatar,QItemLabel,QExpansionItem} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QHeader,QToolbar,QBtn,QToolbarTitle,QImg,QIcon,QMenu,QList,QItem,QItemSection,QDrawer,QAvatar,QItemLabel,QExpansionItem})
